export default {
  statusFilterLateOption: {
    id: 'bo_sellers_customer_care_filter_status_option_late',
    defaultMessage: 'Late',
  },
  statusFilterTodoOption: {
    id: 'bo_sellers_customer_care_filter_status_option_to_do',
    defaultMessage: 'To do',
  },
  statusFilterNoActionNeededOption: {
    id: 'bo_sellers_customer_care_filter_status_option_no_action_needed',
    defaultMessage: 'No action needed',
  },
  statusFilterUpcomingOption: {
    id: 'bo_sellers_customer_care_filter_status_option_upcoming',
    defaultMessage: 'Upcoming',
  },
  statusFilterCompletedOption: {
    id: 'bo_sellers_customer_care_filter_status_option_completed',
    defaultMessage: 'Completed',
  },
  taskFilterSendMessageOption: {
    id: 'bo_sellers_customer_care_filter_task_option_send_message',
    defaultMessage: 'Send message',
  },
  taskFilterUploadReceiptOption: {
    id: 'bo_sellers_customer_care_filter_task_option_upload_receipt',
    defaultMessage: 'Upload receipt',
  },
  taskFilterRepairReplaceOption: {
    id: 'bo_sellers_customer_care_filter_task_option_repair_replace',
    defaultMessage: 'Repair/replace',
  },
  taskFilterRepairOption: {
    id: 'bo_sellers_customer_care_filter_task_option_repair',
    defaultMessage: 'Repair',
  },
  taskFilterReplaceOption: {
    id: 'bo_sellers_customer_care_filter_task_option_replace',
    defaultMessage: 'Replace',
  },
  taskFilterRefundOption: {
    id: 'bo_sellers_customer_care_filter_task_option_refund',
    defaultMessage: 'Refund',
  },
  taskFilterReturnToCustomerOption: {
    id: 'bo_sellers_customer_care_filter_task_option_return_to_customer',
    defaultMessage: 'Return to customer',
  },
  taskFilterReturnTasksSection: {
    id: 'bo_sellers_customer_care_filter_task_section_return_tasks',
    defaultMessage: 'Return tasks',
  },
  status: {
    id: 'bo_sellers_customer_care_filter_status',
    defaultMessage: 'Status',
  },
  task: {
    id: 'bo_sellers_customer_care_filter_task',
    defaultMessage: 'Task',
  },
  orderId: {
    id: 'bo_sellers_customer_care_filter_order_number',
    defaultMessage: 'Order number',
  },
  customerFirstName: {
    id: 'bo_sellers_customer_care_filter_customer_first_name',
    defaultMessage: 'Customer first name',
  },
  customerLastName: {
    id: 'bo_sellers_customer_care_filter_customer_last_name',
    defaultMessage: 'Customer last name',
  },
  market: {
    id: 'bo_sellers_customer_care_filter_market',
    defaultMessage: 'Market',
  },
  issueType: {
    id: 'bo_sellers_customer_care_filter_issue_type',
    defaultMessage: 'Issue type',
  },
  sku: {
    id: 'bo_sellers_customer_care_filter_sku',
    defaultMessage: 'SKU',
  },
  applyFilters: {
    id: 'bo_sellers_customer_care_filter_apply_filters',
    defaultMessage: 'Apply filters',
  },
  reset: {
    id: 'bo_sellers_customer_care_filter_reset',
    defaultMessage: 'Reset',
  },
  seeLessFilters: {
    id: 'bo_sellers_customer_care_filter_see_less_filters',
    defaultMessage: 'See less filters',
  },
  seeMoreFilters: {
    id: 'bo_sellers_customer_care_filter_see_more_filters',
    defaultMessage: 'See more filters',
  },
  modalTitle: {
    id: 'bo_sellers_customer_care_filter_modal_title',
    defaultMessage: 'Filter',
  },
  modalButtonLabel: {
    id: 'bo_sellers_customer_care_filter_modal_filter_button',
    defaultMessage: 'Filter',
  },
  backButtonAriaLabel: {
    id: 'bo_sellers_customer_care_filter_modal_back_button_aria_label',
    defaultMessage: 'Back to filters list',
  },
  closeButtonAriaLabel: {
    id: 'bo_sellers_customer_care_filter_modal_close_button_aria_label',
    defaultMessage: 'Close',
  },
  statusFilterEmptyLabel: {
    id: 'bo_sellers_customer_care_filter_modal_status_filter_empty_label',
    defaultMessage: 'All statuses',
  },
  taskFilterEmptyLabel: {
    id: 'bo_sellers_customer_care_filter_modal_task_filter_empty_label',
    defaultMessage: 'All types',
  },
  marketFilterEmptyLabel: {
    id: 'bo_sellers_customer_care_filter_modal_market_filter_empty_label',
    defaultMessage: 'All markets',
  },
  orderIdWrongFormat: {
    id: 'bo_sellers_customer_care_filter_order_number_wrong_format',
    defaultMessage: 'Order number wrong format',
  },
}
